import api from "api"

const campaigns = {
    get: (slug, params = {}) => {
        return api().get(`/events/detail/${slug}/campaigns`, { params })
    }
}

export default campaigns;
